/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useCatalogEntryList } from '@/data/Content/CatalogEntryList';
import { ContentContext } from '@/data/context/content';
import { Chip, IconButton } from '@mui/material';
import { FC, useContext } from 'react';
import { useFacetNavigation } from '@/data/Content/FacetNavigation';
import { ID } from '@/data/types/Basic';
import CloseIcon from '@mui/icons-material/Close';
import {
	CatalogEntryListFacetChipsCloseIconFrameSX,
	CatalogEntryListFacetChipsCloseIconSX,
	CatalogEntryListFacetChipsPrimarySX,
} from '@/components/content/CatalogEntryList/styles/main';
import { combineSX } from '@/utils/combineSX';
import { DpOfferChipGrid } from '@/components/blocks/DpOfferChip';
import { SAP_OFFERT_STORAGE_KEY } from '@/data/config/SAPOFFERT';

export const PLPFacetOffersChip: FC<{ id: ID }> = ({ id }) => {
	const { onFacetDelete } = useContext(ContentContext) as ReturnType<typeof useCatalogEntryList>;

	const facets = useFacetNavigation(id);
	const offers = facets.facets.filter(
		(e) =>
			e?.name === SAP_OFFERT_STORAGE_KEY ||
			e?.extendedData?.propertyvalue === SAP_OFFERT_STORAGE_KEY
	);

	if (offers.length === 0) {
		return null;
	}

	return (
		<DpOfferChipGrid>
			{(offers.at(0)?.entry ?? []).map((offer) => {
				let isIn = false;

				facets.selectedFacet.forEach((selected) => {
					if (selected === offer.value) {
						isIn = true;
					}
				});

				if (isIn) {
					return (
						<Chip
							color="primary"
							sx={combineSX([
								{
									minWidth: '124px',
								},
								CatalogEntryListFacetChipsPrimarySX,
							])}
							deleteIcon={
								<IconButton sx={CatalogEntryListFacetChipsCloseIconFrameSX} size="small">
									<CloseIcon
										sx={combineSX([
											CatalogEntryListFacetChipsCloseIconSX,
											{
												color: '#fff',
											},
										])}
									/>
								</IconButton>
							}
							key={offer?.value}
							size="medium"
							label={`Oferta ${offer.label}`}
							onClick={onFacetDelete(offer.value)}
							onDelete={onFacetDelete(offer.value)}
							data-testid={`catalog-entry-list-${offer.value}-selected-facet-chip`}
							id={`catalog-entry-list-${offer.value}-selected-facet-chip`}
						/>
					);
				}
				return (
					<Chip
						key={offer?.value}
						color="primary"
						sx={CatalogEntryListFacetChipsPrimarySX}
						size="medium"
						label={`Oferta ${offer.label}`}
						onClick={(event) => facets.onFacetSelectChange(event as any, offer)}
					/>
				);
			})}
		</DpOfferChipGrid>
	);
};
